module.exports = __webpack_public_path__ + "static/img/cs_3.308dbabd.png";